package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.DiagnosisApi
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis
import kz.dentalcrm.app.data.network.response_model.diagnosis.DiagnosisResponse
import kz.dentalcrm.app.domain.DiagnosisRepository

class DiagnosisRepositoryImpl(
    private val diagnosisApi: DiagnosisApi
) : DiagnosisRepository {

    override suspend fun getDiagnosis(
        search: String,
        page: Int,
        pageSize: Int
    ): Result<DiagnosisResponse?> = diagnosisApi.getDiagnosis(
        page = page,
        pageSize = pageSize,
        search = search
    )

    override suspend fun deleteDiagnosis(diagnosis: Diagnosis): Result<Any?> = diagnosisApi.deleteDiagnosis(
        id = diagnosis.id
    )

    override suspend fun editDiagnosis(diagnosis: Diagnosis): Result<Any?> = diagnosisApi.updateDiagnosis(
        id = diagnosis.id,
        name = diagnosis.name ?: ""
    )

    override suspend fun addDiagnosis(name: String) = diagnosisApi.addDiagnosis(name = name)

}